// src/features/analytics/useAnalyticsPlaybackDaily.ts

import { useQuery } from '@tanstack/react-query';
import { AnalyticsApi, type AnalyticsViewScope } from './AnalyticsApi';
import { ANALYTICS_QUERY_KEYS } from '@/lib/constants/analytics';
import type { UtcRange } from '@/shared/utils/utcRange';
import type { AnalyticsEnvelope, PlaybackDailyData } from './types';

export interface UseAnalyticsPlaybackDailyResult {
  playbackDaily: AnalyticsEnvelope<PlaybackDailyData> | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useAnalyticsPlaybackDaily(
  scope: AnalyticsViewScope | null,
  range: UtcRange
): UseAnalyticsPlaybackDailyResult {
  const query = useQuery({
    queryKey: ANALYTICS_QUERY_KEYS.playbackDaily(
      scope?.kind ?? 'account',
      scope?.cid ?? 0,
      range.from,
      range.to
    ),
    queryFn: () => AnalyticsApi.getPlaybackDaily(scope!, range),
    enabled: scope !== null,
    staleTime: 60_000,
  });

  return {
    playbackDaily: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
